var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArcade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 52,
    viewBox: "0 0 46 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_138_2702)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9401 1.2168L33.9944 7.39768L44.9298 13.5786V26.0592V38.4209L33.9944 44.6018L22.9401 50.7827L12.0047 44.6018L1.06934 38.4209V26.0592V13.5786L12.0047 7.39768L22.9401 1.2168Z",
    fill: "white",
    fillOpacity: 0.501961
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9408 3.83203L32.8064 9.41859L42.5532 15.0052V26.0594V37.1137L32.8064 42.5814L22.9408 48.1679L13.194 42.5814L3.44727 37.1137V26.0594V15.0052L13.194 9.41859L22.9408 3.83203Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 2.02067,
    strokeMiterlimit: 2.61313
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9406 0.0283203L34.4703 6.56579L46 12.9844V26.0593V39.0154L34.4703 45.5529L22.9406 51.9715L11.5297 45.5529L0 39.0154V26.0593V12.9844L11.5297 6.56579L22.9406 0.0283203ZM22.9406 1.21695L33.9948 7.39783L44.9302 13.5787V26.0593V38.4211L33.9948 44.602L22.9406 50.7828L12.0052 44.602L1.06977 38.4211V26.0593V13.5787L12.0052 7.39783L22.9406 1.21695Z",
    fill: "#CCCCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9406 18.3335C31.261 18.3335 38.0362 22.8503 38.0362 28.318C38.0362 29.5066 37.6796 30.5764 37.0853 31.6462C35.0646 29.7443 29.4781 28.318 22.9406 28.318C16.4031 28.318 10.9354 29.7443 8.79591 31.6462C8.32046 30.5764 7.96387 29.5066 7.96387 28.318C7.96387 22.8503 14.7391 18.3335 22.9406 18.3335Z",
    fill: "#3D526F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1987 22.9692V23.9201L24.961 24.1578H21.0385L20.8008 23.9201V22.9692L21.0385 22.7314H24.961L25.1987 22.9692Z",
    fill: "white",
    fillOpacity: 0.501961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6202 34.8552C18.2964 34.8552 21.2765 31.9283 21.2765 28.3177C21.2765 24.7072 18.2964 21.7803 14.6202 21.7803C10.944 21.7803 7.96387 24.7072 7.96387 28.3177C7.96387 31.9283 10.944 34.8552 14.6202 34.8552Z",
    fill: "#3D526F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.7959 28.3177C8.7959 25.1084 11.4109 22.6123 14.6202 22.6123V23.3255C11.7675 23.3255 9.50908 25.465 9.50908 28.3177C9.50908 31.0516 11.7675 33.31 14.6202 33.31C17.4729 33.31 19.7313 31.0516 19.7313 28.3177C19.7313 25.465 17.4729 23.3255 14.6202 23.3255V22.6123C17.8295 22.6123 20.4445 25.1084 20.4445 28.3177C20.4445 31.527 17.8295 34.0232 14.6202 34.0232C11.4109 34.0232 8.7959 31.527 8.7959 28.3177Z",
    fill: "white",
    fillOpacity: 0.501961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.38 34.8552C35.0562 34.8552 38.0363 31.9283 38.0363 28.3177C38.0363 24.7072 35.0562 21.7803 31.38 21.7803C27.7038 21.7803 24.7236 24.7072 24.7236 28.3177C24.7236 31.9283 27.7038 34.8552 31.38 34.8552Z",
    fill: "#3D526F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4365 28.3177C25.4365 25.1084 28.1704 22.6123 31.3797 22.6123V23.3255C28.527 23.3255 26.2686 25.465 26.2686 28.3177C26.2686 31.0516 28.527 33.31 31.3797 33.31C34.2324 33.31 36.4908 31.0516 36.4908 28.3177C36.4908 25.465 34.2324 23.3255 31.3797 23.3255V22.6123C34.589 22.6123 37.204 25.1084 37.204 28.3177C37.204 31.527 34.589 34.0232 31.3797 34.0232C28.1704 34.0232 25.4365 31.527 25.4365 28.3177Z",
    fill: "white",
    fillOpacity: 0.501961
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2761 19.1655C21.1572 18.9278 21.1572 18.8089 21.0384 18.5712C20.9195 18.3334 20.8006 18.0957 20.5629 17.858C20.4441 17.5014 20.6818 17.2637 21.2761 17.2637C21.8704 17.2637 22.4647 17.2637 22.9402 17.2637C23.5345 17.2637 24.1288 17.2637 24.7231 17.2637C25.3174 17.2637 25.5552 17.5014 25.4363 17.858C25.1986 18.0957 25.0797 18.3334 24.9609 18.5712C24.842 18.8089 24.7231 18.9278 24.7231 19.1655C24.7231 19.1655 24.2477 19.4032 24.0099 19.4032C23.6534 19.4032 23.2968 19.4032 22.9402 19.4032C22.7025 19.4032 22.3459 19.4032 21.9893 19.4032C21.7516 19.4032 21.2761 19.1655 21.2761 19.1655Z",
    fill: "#3D526F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3888 26.3159C30.3888 26.8425 30.8249 27.2694 31.3629 27.2694C31.9008 27.2694 32.3369 26.8425 32.3369 26.3159C32.3369 25.7892 31.9008 25.3623 31.3629 25.3623C30.8249 25.3623 30.3888 25.7892 30.3888 26.3159Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4001 29.269C33.9253 29.269 34.351 28.8433 34.351 28.3181C34.351 27.7929 33.9253 27.3672 33.4001 27.3672C32.875 27.3672 32.4492 27.7929 32.4492 28.3181C32.4492 28.8433 32.875 29.269 33.4001 29.269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3888 30.2973C30.3888 30.8239 30.8249 31.2509 31.3629 31.2509C31.9008 31.2509 32.3369 30.8239 32.3369 30.2973C32.3369 29.7707 31.9008 29.3438 31.3629 29.3438C30.8249 29.3438 30.3888 29.7707 30.3888 30.2973Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3591 29.269C29.8843 29.269 30.31 28.8433 30.31 28.3181C30.31 27.7929 29.8843 27.3672 29.3591 27.3672C28.8339 27.3672 28.4082 27.7929 28.4082 28.3181C28.4082 28.8433 28.8339 29.269 29.3591 29.269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.333 25.3462H13.9067C13.7754 25.3462 13.6689 25.5058 13.6689 25.7028V30.8139C13.6689 31.0108 13.7754 31.1705 13.9067 31.1705H15.333C15.4643 31.1705 15.5708 31.0108 15.5708 30.8139V25.7028C15.5708 25.5058 15.4643 25.3462 15.333 25.3462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6162 29.0297L17.6162 27.5899C17.6162 27.4631 17.4628 27.3604 17.2736 27.3604L11.9479 27.3604C11.7587 27.3604 11.6053 27.4631 11.6053 27.5899L11.6053 29.0297C11.6053 29.1564 11.7587 29.2592 11.9479 29.2592L17.2736 29.2592C17.4628 29.2592 17.6162 29.1564 17.6162 29.0297Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_138_2702"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArcade);
export default __webpack_public_path__ + "static/media/Arcade.b1426f0628fdf91bdc5ec5606b6ca52d.svg";
export { ForwardRef as ReactComponent };